export default __webpack_public_path__ + "static/InterDisplay-Black-bac5921eac33d14e3299614946a2abfa.woff";